import request from '@/utils/request'


// 查询双色球列表
export function listSsq(query) {
    return request({
        url: '/admin/lottery/ssq/list',
        method: 'get',
        params: query
    })
}

// 查询最新一期双色球数据
export function latestSsq() {
    return request({
        url: '/admin/lottery/ssq/latest',
        method: 'get',
    })
}

// 初始化双色球数据
export function initAllSsq() {
    return request({
        url: '/admin/lottery/ssq/initAll',
        method: 'post'
    })
}

// 补全双色球历史数据
export function fillHistoryData() {
    return request({
        url: '/admin/lottery/ssq/fillHistoryData',
        method: 'post'
    })
}

// 获取双色球号码出现次数
export function getSsqNumData() {
    return request({
        url: '/admin/lottery/ssq/getNumData',
        method: 'get',
    })
}

// 初始化双色球统计数据
export function initAllSsqC() {
    return request({
        url: '/admin/lottery/ssq/initAllC',
        method: 'post'
    })
}

// 刷新双色球缓存
export function refreshSsqCache() {
    return request({
        url: '/admin/lottery/ssq/refreshCache',
        method: 'delete',
    })
}
// 生成双色球
export function generateSsq(data) {
    return request({
        url: '/admin/lottery/ssq/generate',
        method: 'post',
        data:data
    })
}

// 查询双色球中奖数据
export function getSsqWinningData(query){
    return request({
        url: '/admin/lottery/ssq/getWinningData',
        method: 'get',
        params: query
    })
}
// 查询双色球历史同期中奖数据
export function getNextSsqHistory(period){
    return request({
        url: '/admin/lottery/ssq/getNextHistory?period='+period,
        method: 'get'
    })
}


// 查询双色球下期数字频率
export function getNextNumFrequency(query){
    return request({
        url: '/admin/lottery/ssq/getNextNumFrequency',
        method: 'get',
        params: query
    })
}
